/**
 * NotFoundPage Component
 * 404 error page with navigation options
 */

import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AppLayout from '../components/layouts/AppLayout';

function NotFoundPage(): JSX.Element {
  const navigate = useNavigate();

  return (
    <AppLayout showNavigation>
      <Container maxWidth="md">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 'calc(100vh - 200px)',
            py: 4,
          }}
        >
          <Typography variant="h1" gutterBottom>
            404
          </Typography>
          <Typography variant="h4" gutterBottom>
            Page Not Found
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, textAlign: 'center' }}>
            The page you are looking for does not exist or has been moved.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Button variant="contained" onClick={() => navigate('/')}>
              Go to Quiz
            </Button>
          </Box>
        </Box>
      </Container>
    </AppLayout>
  );
}

export default NotFoundPage;
